module.exports = __webpack_public_path__ + "static/media/Group 1336.9a23117e.svg";